import { render, staticRenderFns } from "./RoomElements.vue?vue&type=template&id=2e1bfd36&scoped=true&"
import script from "./RoomElements.vue?vue&type=script&lang=js&"
export * from "./RoomElements.vue?vue&type=script&lang=js&"
import style0 from "./RoomElements.vue?vue&type=style&index=0&id=2e1bfd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1bfd36",
  null
  
)

export default component.exports